import { DextTextInputWUT } from '@wix/form-fields/viewer-wut';

export default DextTextInputWUT;
